import { forwardRef } from 'react'

import { SENTIMENT_BORDER } from './sentimentBorder'
import type { SentimentIconProps } from './types'

const FILL = 'var(--hsds-token-color-red-accent, #FF4747)'
const PATH =
  'M13.6571 13.6569C10.5329 16.781 5.4676 16.781 2.34341 13.6569C-0.780784 10.5327 -0.780784 5.46734 2.34341 2.34315C5.4676 -0.781049 10.5329 -0.781049 13.6571 2.34315C16.7813 5.46734 16.7813 10.5327 13.6571 13.6569ZM11.5358 8.70711C11.9263 8.31658 11.9263 7.68342 11.5358 7.29289C11.1453 6.90237 10.5121 6.90237 10.1216 7.29289L9.00016 8.41432V5.17157C9.00016 4.61929 8.55255 4.17168 8.00026 4.17168C7.44801 4.17171 7.00037 4.61931 7.00037 5.17157V8.41432L5.87894 7.29289C5.48842 6.90237 4.85525 6.90237 4.46473 7.29289C4.07421 7.68342 4.07421 8.31658 4.46473 8.70711L7.29316 11.5355C7.68368 11.9261 8.31685 11.9261 8.70737 11.5355L11.5358 8.70711Z'

// Negative sentiment — red circle with a downward arrow. The `border`
// variant renders the same glyph in a 20×20 box behind a white border so it
// reads on colored backgrounds (mirrors the Figma `Border=True` asset).
const NegativeSentimentIcon = forwardRef<SVGSVGElement, SentimentIconProps>(
  function NegativeSentimentIcon({ border = false, ...rest }, ref) {
    if (border) {
      return (
        <svg
          ref={ref}
          width={20}
          height={20}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...rest}
        >
          {SENTIMENT_BORDER}
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            transform="translate(2 2)"
            d={PATH}
            fill={FILL}
          />
        </svg>
      )
    }

    return (
      <svg
        ref={ref}
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <path fillRule="evenodd" clipRule="evenodd" d={PATH} fill={FILL} />
      </svg>
    )
  }
)

export { NegativeSentimentIcon }
